import axios, { API } from 'config/axios';
import { useLayoutState } from 'components/shared/Layout';
import useHandleResponse from 'utils/useHandleResponse';
import Talk from 'talkjs';
import getConfig from 'next/config';

const openChatPopUp = (conversation) => {
  if (conversation && window.talkSession) {
    const popup = window.talkSession.createPopup(conversation, {
      keepOpen: false,
    });
    popup.mount({ show: true });
  }
};
const useTalkJS = () => {
  const { handleError } = useHandleResponse();
  const {
    publicRuntimeConfig: { envVars },
  } = getConfig();
  const { layoutState } = useLayoutState();
  const currentUser = layoutState.current_user;

  const getConversationId = async (user) => {
    try {
      const { data } = await axios
        .post(API.communication.findOrCreate, {
          user_id: currentUser.id,
          other_user_id: user.user_id,
          authenticity_token: layoutState.authenticity_token,
        });
      if (data) {
        return data;
      }
    } catch (error) {
      handleError(error);
    }
    return true;
  };

  const openTalkJsPopup = (otherUser = {}) => {
    getConversationId(otherUser).then((res) => {
      Talk.ready.then(() => {
        const me = new Talk.User({
          id: currentUser.id,
          name: currentUser.first_name + currentUser.last_name,
          email: currentUser.email,
          photoUrl: currentUser.avatar_url,
          // phone: currentUser.phone,
          role: otherUser.role == 'seller' ? 'buyer' : 'seller',
        });
        const other = new Talk.User({
          id: otherUser.user_id,
          name: otherUser.name,
          photoUrl: otherUser.avatar_url,
          // phone: otherUser.phone,
          email: otherUser.email,
          role: otherUser.role,
        });
        if (!window.talkSession) {
          window.talkSession = new Talk.Session({
            appId: envVars.TALKJS_APP_ID,
            me,
            signature: currentUser.talkjs_signed_user_id,
          });
        }

        const conversation = window.talkSession.getOrCreateConversation(
          res.conversation_id,
        );

        conversation.setParticipant(me);
        conversation.setParticipant(other);
        openChatPopUp(conversation);
      });
    });
  };

  return { getConversationId, openTalkJsPopup };
};

export default useTalkJS;
